import { render, staticRenderFns } from "./resProtocol.vue?vue&type=template&id=1eec2912&"
import script from "./resProtocol.vue?vue&type=script&lang=js&"
export * from "./resProtocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "resProtocol.vue"
export default component.exports